// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
.popup-mask {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.popup-header {
  position: relative;
  padding: 16px 36px 0;
  color: #9dbcda;
  text-align: center;
}

.popup-close {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  color: #9dbcda;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.popup-content {
  color: #9dbcda;
  overflow: auto;
  padding: 12px 16px;
}

.popup-footer {
  padding: 0 16px 16px;
}

.popup-btn {
  padding: 10px 20px;
  height: 45px;
  margin: 5px;
  flex-grow: 1;
  max-width: 200px;
  border-radius: 5px;
  border: 2px solid transparent;
  background: #3e84c9;
  color: #dce8f3;
  cursor: pointer;
}
.popup-btn.outlined {
  background: transparent;
  border-color: #99bdd1;
  color: #9dbcda;
}
.popup-btn.danger {
  background: #c85573;
  color: #dce8f3;
}
.popup-btn:disabled {
  background: #3f5061;
  color: #607387;
  cursor: default;
}

.display-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}
.display-text > div {
  margin-bottom: 20px;
}
.display-text :last-child {
  margin-bottom: 0;
}

/* Popup footer — overrides shared form .button-container alignment */
.button-container {
  display: flex;
  justify-content: center;
}

.key-value-exceptions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.key-value-exceptions .key-values {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.key-value-exceptions .key-values .values {
  margin-left: 30px;
  display: flex;
  flex-wrap: wrap;
}
.key-value-exceptions .key-values .values > div {
  margin: 0 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
